import { emailRegexValidation } from '../../utils/validate';

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'emptyField';
  }

  if (!values.phone_number) {
    errors.phone_number = 'emptyField';
  }

  if (values.email && !emailRegexValidation(values.email)) {
    errors.email = 'wrongEmail';
  }

  return errors;
};

export default validate;
